"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _DEKAT4J4cjs = require('../__chunks/DEKAT4J4.cjs');



var _QWIBF3KBcjs = require('../__chunks/QWIBF3KB.cjs');
require('../__chunks/2XVCJUVB.cjs');
require('../__chunks/NSONUP5C.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/tab/tab.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "button";
var useTab = _PTOCUU2Dcjs.createHook.call(void 0, function useTab2({
  store,
  getItem: getItemProp,
  ...props
}) {
  var _a;
  const context = _DEKAT4J4cjs.useTabScopedContext.call(void 0, );
  store = store || context;
  _misc.invariant.call(void 0, 
    store,
    process.env.NODE_ENV !== "production" && "Tab must be wrapped in a TabList component."
  );
  const defaultId = _3BSDKDKDcjs.useId.call(void 0, );
  const id = props.id || defaultId;
  const dimmed = _misc.disabledFromProps.call(void 0, props);
  const getItem = _react.useCallback.call(void 0, 
    (item) => {
      const nextItem = { ...item, dimmed };
      if (getItemProp) {
        return getItemProp(nextItem);
      }
      return nextItem;
    },
    [dimmed, getItemProp]
  );
  const onClickProp = props.onClick;
  const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    store == null ? void 0 : store.setSelectedId(id);
  });
  const panelId = _FH6HQ5JNcjs.useStoreState.call(void 0, 
    store.panels,
    (state) => {
      var _a2;
      return (_a2 = state.items.find((item) => item.tabId === id)) == null ? void 0 : _a2.id;
    }
  );
  const shouldRegisterItem = defaultId ? props.shouldRegisterItem : false;
  const isActive = _FH6HQ5JNcjs.useStoreState.call(void 0, 
    store,
    (state) => !!id && state.activeId === id
  );
  const selected = _FH6HQ5JNcjs.useStoreState.call(void 0, 
    store,
    (state) => !!id && state.selectedId === id
  );
  const hasActiveItem = _FH6HQ5JNcjs.useStoreState.call(void 0, 
    store,
    (state) => !!store.item(state.activeId)
  );
  const canRegisterComposedItem = isActive || selected && !hasActiveItem;
  const accessibleWhenDisabled = selected || ((_a = props.accessibleWhenDisabled) != null ? _a : true);
  const isWithinVirtualFocusComposite = _FH6HQ5JNcjs.useStoreState.call(void 0, 
    store.combobox || store.composite,
    "virtualFocus"
  );
  if (isWithinVirtualFocusComposite) {
    props = {
      ...props,
      tabIndex: -1
    };
  }
  props = {
    role: "tab",
    "aria-selected": selected,
    "aria-controls": panelId || void 0,
    ...props,
    id,
    onClick
  };
  if (store.composite) {
    const defaultProps = {
      id,
      accessibleWhenDisabled,
      store: store.composite,
      shouldRegisterItem: canRegisterComposedItem && shouldRegisterItem,
      rowId: props.rowId,
      render: props.render
    };
    props = {
      ...props,
      render: /* @__PURE__ */ _jsxruntime.jsx.call(void 0, 
        _QWIBF3KBcjs.CompositeItem,
        {
          ...defaultProps,
          render: store.combobox && store.composite !== store.combobox ? /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _QWIBF3KBcjs.CompositeItem, { ...defaultProps, store: store.combobox }) : defaultProps.render
        }
      )
    };
  }
  props = _QWIBF3KBcjs.useCompositeItem.call(void 0, {
    store,
    ...props,
    accessibleWhenDisabled,
    getItem,
    shouldRegisterItem
  });
  return props;
});
var Tab = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function Tab2(props) {
    const htmlProps = useTab(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.Tab = Tab; exports.useTab = useTab;
